<template>
    <v-dialog v-model="show" max-width="900" persistent>
        <v-card v-if="show">
            <v-toolbar color="primary" dark elevation="0">
                <v-toolbar-title>Envio de arquivo anexo à negociação</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            
            <v-card-text class="pt-5">
                <p class="text-body-2 grey--text text--darken-1">
                    O arquivo de negociação ajudará a entender mais sobre a negociação concedida ao cliente e o formato de mídia.
                </p>

                <v-divider class="my-4"></v-divider>

                <v-row>
                    <v-col cols="6">
                        <div class="upload-label mb-3">Arquivo</div>
                    </v-col>
                    <v-col cols="6">
                        <div class="upload-label mb-3">Observação</div>
                    </v-col>
                </v-row>

                <v-row class="align-start">
                    <v-col cols="6">
                        <div class="upload-section">
                            <FileUpload
                                :target="`grid-attachments/${item.orderGridId}`"
                                :error="errors.file"
                                :snap="form.files"
                                @set-upload="handleFileUpload($event)"
                            />

                            <div class="existing-files mt-4">
                                <div class="upload-label mb-2">Arquivos já enviados nesta grid</div>

                                <div v-if="loadingAttachments" class="d-flex align-center grey--text text--darken-1 py-3">
                                    <v-progress-circular indeterminate size="18" width="2" class="mr-2"></v-progress-circular>
                                    <span class="text-body-2">Carregando...</span>
                                </div>

                                <div v-else-if="!existingFiles.length" class="grey--text text--darken-1 text-body-2 py-3">
                                    Nenhum arquivo enviado ainda.
                                </div>

                                <v-list v-else dense class="py-0 existing-files-list">
                                    <v-list-item
                                        v-for="(file, i) in existingFiles"
                                        :key="i"
                                        class="px-2 existing-file-item"
                                    >
                                        <v-list-item-icon class="mr-2 my-2">
                                            <v-icon small>{{ fileIcon(file.name) }}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="py-1">
                                            <v-list-item-title class="text-body-2" :title="file.name">
                                                {{ file.name }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="caption">
                                                {{ formatDate(file.createdOn) }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action class="my-0">
                                            <v-btn
                                                icon
                                                small
                                                color="primary"
                                                :loading="downloadingId === i"
                                                :title="`Baixar ${file.name}`"
                                                @click="downloadFile(file, i)"
                                            >
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </div>
                    </v-col>
                    
                    <v-col cols="6">
                        <div class="observation-section">
                            <v-textarea
                                v-model="form.observation"
                                placeholder="Incluir observação..."
                                outlined
                                hide-details
                                :error="errors.observation"
                            ></v-textarea>
                        </div>
                    </v-col>
                </v-row>

                <v-divider class="my-4"></v-divider>

                <div class="info-section">
                    <v-row dense>
                        <v-col cols="6">
                            <div class="info-item">
                                <strong>Inventário:</strong> {{ item.asuFormat?.display_name || '-' }}
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <div class="info-item">
                                <strong>Formato:</strong> {{ formatText }}
                            </div>
                        </v-col>
                    </v-row>
                    
                    <v-row dense>
                        <!-- <v-col cols="6" v-if="item.asuFormat?.asus?.asu_client_id">
                            <div class="info-item" >
                                <strong>Código:</strong> {{ item.asuFormat.asus.asu_client_id }}
                            </div>
                        </v-col> -->
                        <v-col cols="6">
                            <div class="info-item">
                                <strong>Detalhes:</strong> {{ detailsText }}
                            </div>
                        </v-col>
                            <v-col cols="6">
                            <div class="info-item">
                                <strong>Localização:</strong> {{ locationText }}
                            </div>
                        </v-col>
                    </v-row>
                    
                    <v-row dense>
                    
                    </v-row>
                </div>
            </v-card-text>

            <v-card-actions class="px-6 pb-4">
                <v-spacer></v-spacer>
                <v-btn 
                    text 
                    @click="closeModal"
                    :disabled="loading"
                >
                    Cancelar
                </v-btn>
                <v-btn 
                    color="success" 
                    elevation="0"
                    @click="sendAttachment"
                    :loading="loading"
                    :disabled="!form.files || !form.files.length"
                >
                    Enviar anexo
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.color"
            timeout="4000"
            top
            right
        >
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar.show = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import FileUpload from '@/interface/FileUpload.vue'

export default {
    name: 'AttachmentUploadModal',
    components: {
        FileUpload
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            form: {
                files: [],
                observation: ''
            },
            errors: {
                file: false,
                observation: false
            },
            snackbar: {
                show: false,
                text: '',
                color: 'error'
            },
            fileError: false,
            existingAttachments: [],
            loadingAttachments: false,
            downloadingId: null
        }
    },
    computed: {
        show: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        formatText() {
            if (!this.item.asuFormat?.asus?.format) return '-'
            const format = this.item.asuFormat.asus.format
            return this.$options.filters.asuFormat(format)
        },
        detailsText() {
            if (!this.item.asuFormat?.asus?.bucket) return '-'
            return this.$options.filters.asuBuckets(this.item.asuFormat.asus.bucket)
        },
        locationText() {
            if (!this.item.asuFormat?.asus?.locations?.length) return '-'
            
            const firstLocation = this.$options.filters.location(this.item.asuFormat.asus.locations[0])
            const additionalCount = this.item.asuFormat.asus.locations.length - 1
            
            if (additionalCount > 0) {
                return `${firstLocation} +${additionalCount} localidade${additionalCount > 1 ? 's' : ''}`
            }
            
            return firstLocation
        },
        existingFiles() {
            const result = []
            this.existingAttachments.forEach((record) => {
                (record.files || []).forEach((file) => {
                    result.push({
                        name: file.name,
                        url: file.url,
                        createdOn: record.createdOn
                    })
                })
            })
            return result
        }
    },
    watch: {
        show(val) {
            if (val) {
                this.resetForm()
                this.loadAttachments()
            }
        },
        'form.files'(newVal, oldVal) {
            
            if (Array.isArray(newVal) && Array.isArray(oldVal)) {
                if (newVal.length < oldVal.length && this.fileError) {
                    this.snackbar.text = 'Arquivo não suportado ou muito grande. O arquivo foi removido.'
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                    this.fileError = false
                }
            }
        }
    },
    methods: {
        handleFileUpload(files) {
            console.log('Files uploaded:', files)
            if (files && Array.isArray(files)) {
                this.form.files = files
            } else if (!files) {
                
                this.fileError = true
            }
        },
        resetForm() {
            this.form = {
                files: [],
                observation: ''
            }
            this.errors = {
                file: false,
                observation: false
            }
            this.fileError = false
            this.snackbar.show = false
        },
        closeModal() {
            this.show = false
        },
        async loadAttachments() {
            this.existingAttachments = []
            if (!this.item.orderGridId) return

            this.loadingAttachments = true
            try {
                const params = new URLSearchParams()
                params.set('pg', 1)
                params.set('pp', 100)
                params.set('gridId', this.item.orderGridId)

                const res = await this.$axios.get(`/grids/attachments?${params.toString()}`)
                const data = res.data.data
                this.existingAttachments = data.result || []
            } catch (error) {
                console.error('Erro ao carregar anexos existentes:', error)
            } finally {
                this.loadingAttachments = false
            }
        },
        fileIcon(name) {
            const ext = (name || '').split('.').pop().toLowerCase()
            if (['xls', 'xlsx', 'csv'].includes(ext)) return 'mdi-file-excel-outline'
            if (['doc', 'docx'].includes(ext)) return 'mdi-file-word-outline'
            if (ext === 'pdf') return 'mdi-file-pdf-box'
            if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) return 'mdi-file-image-outline'
            return 'mdi-file-outline'
        },
        formatDate(ts) {
            if (!ts) return '—'
            const ms = Number(ts) < 1e12 ? Number(ts) * 1000 : Number(ts)
            const d = new Date(ms)
            if (Number.isNaN(d.getTime())) return '—'
            return d.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        async downloadFile(file, index) {
            this.downloadingId = index
            try {
                const res = await this.$axios.get(file.url, { responseType: 'blob' })
                const blobUrl = window.URL.createObjectURL(res.data)
                const a = document.createElement('a')
                a.href = blobUrl
                a.download = file.name || 'download'
                document.body.appendChild(a)
                a.click()
                a.remove()
                window.URL.revokeObjectURL(blobUrl)
            } catch (error) {
                console.error('Erro ao baixar arquivo:', error)
                window.open(file.url, '_blank', 'noopener')
            } finally {
                this.downloadingId = null
            }
        },
        validateForm() {
            this.errors.file = !this.form.files || !this.form.files.length
            
            return !this.errors.file
        },
        async sendAttachment() {
            if (this.loading) {
                return
            }

            if (!this.validateForm()) {
                return
            }

            this.loading = true

            try {
                const payload = {
                    gridId: this.item.orderGridId,
                    files: this.form.files,
                    observation: this.form.observation,
                    userName: this.$root.auth?.user?.name || '',
                }

                await this.$axios.post('/grids/attachments', payload)

                this.snackbar.text = 'Arquivo enviado com sucesso!'
                this.snackbar.color = 'success'
                this.snackbar.show = true

                this.$emit('attachment-uploaded', payload)
                this.loadAttachments()

                setTimeout(() => {
                    this.closeModal()
                    this.loading = false
                }, 1000)

            } catch (error) {
                console.error('Erro ao enviar anexo:', error)
                this.snackbar.text = 'Erro ao enviar arquivo. Tente novamente.'
                this.snackbar.color = 'error'
                this.snackbar.show = true
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.upload-section,
.observation-section {
    height: 100%;
}

.upload-label {
    font-weight: 500;
    font-size: 14px;
    color: #424242;
    margin-top: 5px;
}

.observation-section .v-textarea {
    height: 260px;
}

.observation-section >>> .v-text-field__slot textarea {
    height: 173px !important;
}

.info-section {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 4px;
}

.info-item {
    font-size: 14px;
    margin-bottom: 8px;
}

.info-item strong {
    color: #424242;
}
</style>
